import React from 'react';
import LOR from '../assets/projects/LOR.png';
import Jchat from '../assets/projects/Jchat.png'
import Gig from '../assets/projects/gig.png'
import Habit_track from '../assets/projects/habit_track.png'
import stayfinder from '../assets/projects/stayfinder.png'
import nutriscale from '../assets/projects/nutriscale.png'
import aibot from '../assets/projects/aibot.jpg'
import {Link} from "react-router-dom"


const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Optional: Scroll behavior
    });
  }

const Work = () => {

return (
    <div id="work" name='work'className='w-full md:h-[115vh] py-20 text-gray-300 bg-[#0a192f]'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col w-full h-full '>
            <div className='pb-2' >
                <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
                    Work</p>
                <p className='py-6'>// Checkout some of my recent work</p>
            </div>

{/* container */}
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4 pr-3 overflow-y-auto'>

                {/* Grid item */}
                <div style={{backgroundImage:`url(${nutriscale})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Nutriscale
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/nutriscale'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/NutriScale" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>



                <div style={{backgroundImage:`url(${aibot})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            LLM: JusticeBot
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/justice'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/DOJ-ai-assistant" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>


                <div style={{backgroundImage:`url(${stayfinder})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            MERN: StayFinder
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/stayfinder'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/Stayfinder" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>



                <div style={{backgroundImage:`url(${LOR})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Python LOR Application using NLP
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/lor'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/LOR_python_app" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>



                <div style={{backgroundImage:`url(${Gig})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            MERN: Freelance site
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/gig'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/GigGuild" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>







                <div style={{backgroundImage:`url(${Habit_track})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md  
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            FLUTTER: Habit Tracker
                        </span>
                        <div className='pt-8 text-center'>
                            <Link to='/habit_track'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg' onClick={scrollToTop}>View</button>
                            </Link>

                            <a href="https://github.com/varadk20/habit-tracker" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>



                

                <div style={{backgroundImage:`url(${Jchat})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md 
              flex justify-center items-center mx-auto content-div'>

            {/*   Hover effect */}

                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Java Chat Application
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/jchat">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>View</button>
                            </a>

                            <a href="https://github.com/varadk20/Java-Chat-Application" target='_blank'>
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                                font-bold text-lg'>Code</button>
                            </a>
                        </div>

                    </div>
                </div>

               
            </div>
        </div>
    </div>
)
}

export default Work;
